const { defineMessages } = require('@sm/intl');

const COPY = defineMessages({
  ALWAYS_FREE: {
    id: 'Pricing.AlwaysFreeByline',
    defaultMessage: 'Always free',
    desc: '[Type: Text][Vis: high] - Always free byline',
  },
  PER_MONTH: {
    id: 'Pricing.PricePerMonthByline',
    defaultMessage: '/ month',
    desc: '[Type: Text][Vis: high] - Price per month byline',
  },
  PER_USER_PER_MONTH: {
    id: 'Pricing.PricePerUserPerMonthByline',
    defaultMessage: '/ user / month',
    desc: '[Type: Text][Vis: high] - Price per user per month byline',
  },
  BILLED_ANNUALLY: {
    id: 'Pricing.PriceBilledAnnuallyByline',
    defaultMessage: 'Starting at 3 users, billed annually',
    desc: '[Type: Text][Vis: high] - Price billed annually byline',
  },
  PER_MONTH_ANNUALLY: {
    id: 'Pricing.PerMonthAnnuallyByline',
    defaultMessage: `{price} billed annually`,
    desc: '[Type: Text][Vis: high] - Price per month billed annually byline',
  },
  ENTERPRISE: {
    id: 'Pricing.EnterpriseByline',
    defaultMessage: 'Powerful admin tools, integrations, and collaboration features for your organization.',
    desc: '[Type: Text][Vis: high] - Enterprise pricing byline',
  },
  BR_BILLED_ANNUALLY: {
    id: 'Pricing.PortugueseBilledAnnually',
    defaultMessage: 'Paid annually for 3 users (up front)',
    desc: '[Type: Text][Vis: high] - Portuguese billed annually byline',
  },
});

export default COPY;
